import type { FC } from "react"
import { Box, Flex, Stack, Text } from "@chakra-ui/react"

import type { Organization, Proposal } from "query/graphql"
import GovernanceAvatar from "governance/components/GovernanceAvatar"
import { getProposalIdLabel } from "proposal/helpers/id"

type VotingModalProposalDataProps = {
  organization?: Organization
  proposal: Proposal
  governanceName: string
  title: string
}

const VotingModalProposalData: FC<VotingModalProposalDataProps> = ({
  organization,
  proposal,
  governanceName,
  title,
}) => {
  return (
    <Stack align="left" justify="flex-start" px={8} py={2}>
      <Text as="h5" textStyle="h5">
        {title}
      </Text>
      <Flex align="center" justify="space-between" w="full">
        <Stack isInline align="center" spacing={2}>
          {proposal?.onchainId ? (
            <Text color="gray.500" textStyle="body.bold.lg">
              Proposal ID: {getProposalIdLabel(proposal.onchainId)}
            </Text>
          ) : null}
          <Box bg="gray.500" h={1} rounded="full" w={1} />
          <Stack
            isInline
            align="center"
            bg="gray.50"
            borderRadius={12}
            px={2}
            py={1}
            spacing={1}
          >
            {organization?.metadata?.icon ? (
              <GovernanceAvatar size={6} src={organization?.metadata?.icon} />
            ) : null}
            <Text color="gray.900" textStyle="body.bold.md">
              {governanceName}
            </Text>
          </Stack>
        </Stack>
      </Flex>
    </Stack>
  )
}

export default VotingModalProposalData
